import BookAppointment from '@/src/pages/Patient/Appointment/BookAppointment'
import EncounterDetails from '@/src/pages/Patient/Charts/components/Encounters/EncounterDetails'
import VisitSummaryModal from '@/src/pages/Patient/Charts/components/Encounters/VisitSummaryModal'
import RescheduleAppointment from '@/src/pages/Patient/Appointment/RescheduleAppointment'
import { CancelAppointment, RemoveAppointment } from '@admin/Appointment/Modal'
import type { ComponentType } from 'react'
import { Fragment } from 'react'
import { useModalStore } from './modalstore'

export enum PATIENT_MODAL_TYPE {
  CREATE_APPOINTMENT = 'PATIENT_CREATE_APPOINTMENT',
  CANCEL_APPOINTMENT = 'PATIENT_CANCEL_APPOINTMENT',
  RESCHEDULE_APPOINTMENT = 'PATIENT_RESCHEDULE_APPOINTMENT',
  REMOVE_APPOINTMENT = 'PATIENT_REMOVE_APPOINTMENT',
  VIEW_ENCOUNTER_DETAILS = 'PATIENT_VIEW_ENCOUNTER_DETAILS',
  VIEW_VISIT_SUMMARY = 'PATIENT_VIEW_VISIT_SUMMARY'
}

const Modals: Array<{ component: ComponentType<any>; value: PATIENT_MODAL_TYPE }> = [
  { component: BookAppointment, value: PATIENT_MODAL_TYPE.CREATE_APPOINTMENT },
  { component: CancelAppointment, value: PATIENT_MODAL_TYPE.CANCEL_APPOINTMENT },
  { component: RescheduleAppointment, value: PATIENT_MODAL_TYPE.RESCHEDULE_APPOINTMENT },
  { component: RemoveAppointment, value: PATIENT_MODAL_TYPE.REMOVE_APPOINTMENT },
  { component: EncounterDetails, value: PATIENT_MODAL_TYPE.VIEW_ENCOUNTER_DETAILS },
  { component: VisitSummaryModal, value: PATIENT_MODAL_TYPE.VIEW_VISIT_SUMMARY }
]

export const PatientModal = () => {
  const { activeModal, closeModal } = useModalStore()

  return (
    <>
      {Modals.map(({ component: Component, value }) => {
        const activeEntry = activeModal.find(({ modal }) => modal === value)
        const modalProps = (activeEntry?.modalProps as Record<string, any>) || {}
        const reset = modalProps.reset as (() => void) | undefined
        const isOpen = activeEntry != null

        return (
          <Fragment key={value}>
            {isOpen && (
              <Component
                isOpen={isOpen}
                key={value}
                onClose={() => {
                  closeModal(value, reset)
                }}
                {...modalProps}
              />
            )}
          </Fragment>
        )
      })}
    </>
  )
}
